module.exports = __webpack_public_path__ + "static/img/svip_zh_content.5a4a901c.png";